<script>
    
    import { getRole, getUserId } from "../../js/localInfo";
    import { post } from "../../js/labit-connection";
    import { clickOutside } from './clickOutside.js';

    import TextEdit from "../../components/TextEdit.svelte";
    import Combobox from "../../components/Combobox.svelte";
    import MultiSelector from "../../components/MultipleSelect/MultipleSelect.svelte";
    import Calendar from "./Calendar.svelte";
    import { } from "../../js/formatDateTime";
    import Popup from "../../components/Popup.svelte";
    import Chart from "./Chart.svelte";

    let showPopup = false;
    let display = "none";
    let companies = [];
    let projects = [];
    let billable = true;
    let tasks = [];

    let employees = [];
    let selectedEmployees = [];

    let taskTypes = [];
    let selectedTaskTypes = [];
    
    let taskObj = []; // Cómo utilizo esto en chartJS?
    let selectedTaskObj = [];

    let startDate = moment().startOf("isoWeek");
    let endDate = moment().endOf("isoWeek");
    
    $: startDateStr = startDate.format("YYYY-MM-DD");
    $: endDateStr = endDate.format("YYYY-MM-DD");

    $: startDateTimestamp = startDate.format("x");
    $: endDateTimestamp = endDate.format("x");



    /*
    const getTimeRange = (
            start = moment().startOf("week").format("x"), 
            end = moment().endOf("week").format("x")
        ) => {
        
            // TODO: pasar de string del input a timestamp

        return [start, end];
    }
    */

    const onlyUnique = (value, index, self) => {
        return self.indexOf(value) === index;
    }

    const onlyUniqueObject = (value, index, self) => {
        return index === self.findIndex((t) => ( t.value === value.value ));
    }

    const getFilters = async (start = 1632838500000, end = 1635165900539) => {

        start = parseInt(start);
        end = parseInt(end);
        
        let query = `select t.id, tt.id as 'task_type_id', tt.name, t.start, t.end , t.user_id, p.name as userName from tasks as t join task_type as tt on t.task_type_id = tt.id join people as p on t.user_id = p.contact_id where t.start >= ${start} and t.end <= ${end};`;
        let res = await post(query);

        taskTypes = [];
        employees = [];
        selectedEmployees = [];
        selectedTaskTypes = [];

        for (var i = 0; i < res.length; i++) { // Algo mas rapido que un foreach o map
            /*
            taskObj[res[i].id] = {
                start: res[i].start,
                end: res[i].end,
                value: res[i].user_id,
                label: res[i].userName
            };
            */
            // taskTypes[res[i].task_type_id] = res[i].name;

            //taskObj = [...taskObj, {value:res[i].user_id,label: res[i].userName,start: res[i].start,end: res[i].end}]
            taskTypes = [...taskTypes, { value: res[i].task_type_id, label: res[i].name }];
            employees = [...employees, { value: res[i].user_id, label: res[i].userName }];

        }

        employees = employees.filter(onlyUniqueObject);
        taskTypes = taskTypes.filter(onlyUniqueObject);

        selectedEmployees = [...selectedEmployees, employees[0]];
        selectedTaskTypes = [...selectedTaskTypes, taskTypes[0]];
        
/*
        query = `SELECT company_id, Name from companies;`;
        let companies = await post(query);

        query = `SELECT company_id, Name from companies;`;
        //const
*/
    }

    const onClickOutside = async () => {
        display = "none"
    }

    const findData = async (filters) => {
        //if (!(filters.selectedEmployees || filters.selectedTaskTypes || filters.time[0] || filters.time[1])) {
        if (filters.employees.length === 0 || filters.taskTypes.length === 0  || filters.time[0] === "" || filters.time[1] === "") {
            
            // TODO: VERIFICAR BIEN
            showPopup = true;

        } else {
            showPopup = true;
            const query = `
                select from tasks
            `;
        }
    }

    const applyFilter = async () => {

    }

    const clickedPopup = () => {
        showPopup = false;
    }

    (async () => {
        //const [start, end] = getTimeRange();
        //await getFilters(start, end); // ADD AWAIT¿?
        await getFilters(startDateTimestamp, endDateTimestamp); // ADD AWAIT¿?

    })();

</script>

{#if showPopup}
    <div class="alertDiv">
        <Popup
            popupType="alert"
            popupText="Invalid data."
            on:dispatchedClick={clickedPopup}
        />
    </div>
{/if}

<div class="wh-100">
    <div class="filters d-flex">
        <div class="headerCombobox">
            <MultiSelector
                text="People"
                options={employees}
                bind:selected={selectedEmployees}
                width="165px"
            />
        </div>
        <div class="headerCombobox">
            <MultiSelector
                text=""
                options={taskTypes}
                bind:selected={selectedTaskTypes}
                width="165px"
            />
        </div>
        <div class="headerCombobox">
            <MultiSelector
                text=""
                options={taskObj}
                bind:selected={selectedTaskObj}
                width="165px"
            />
        </div>

        <div class="btn noselect" on:click={ () => display = display === "none" ? "block" : "none" }>{startDateStr} - {endDateStr}</div>
        
        <div use:clickOutside on:click_outside={onClickOutside} style="display: {display}">
            <Calendar 
                bind:start={startDateStr}
                bind:end={endDateStr}
                onChange={(startDateTimestamp, endDateTimestamp)}
            />
        </div>

        <button class="search noselect" on:click={ () => findData({ employees: selectedEmployees, taskTypes: selectedTaskTypes, time: [startDateTimestamp, endDateTimestamp] }) }></button>
    </div>

    <div class="chart">
        <Chart />
    </div>
</div>

<style>

    .alertDiv {
        position: absolute;
        width: 350px;
        height: 200px;
        top: 40%;
        left: 41%;
        border-radius: 10px;
        background-color: #d7e1ea;
        z-index: 1;
        box-shadow: 2px 1px 3px 0px #afafaf;
    }
    .chart {
        width: 100%;
        height: 90%;
        padding: 1%;
    }
    .search {
        width: 32px;
        height: 32px;
        background-image: url(/images/loupe.svg);
        background-repeat: no-repeat;
        background-color: transparent;
        border: none;
        cursor: pointer;
    }
    .btn {
        width: 175px;
        height: 20px;
        border-radius: 960px/960px;
        cursor: pointer;
        background-color: var(--labit-background-gray);
        border: 1px solid var(--labit-gray);
        text-align: center;
    }
    .wh-100 {
        width: 100%;
        height: 100%;
    }
    .filters {
        justify-content: space-evenly;
        width: 100%;
        padding: 0 10%;
        align-items: center;
        padding-bottom: 2%;
    }
    .d-flex {
        display: flex;
    }
    .headerCombobox {
        width: 175px;
        height: 20px;
    }

    .noselect {
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
    }
</style>